export default [
  {
    title: 'Partner',
    komicon: 'k-user-tick',
    children: [
      {
        title: 'Information',
        komicon: 'k-graph',
        route: 'information',
        resource: 'Partner - Information',
        action: 'manage',
      },
      {
        title: 'Verifikasi Partner',
        tagVariant: 'light-warning',
        route: 'verification-ktp',
        resource: 'Partner - Verifikasi Partner',
        action: 'manage',
        komicon: 'k-user-tick',
      },
      {
        title: 'Sektor Bisnis',
        komicon: 'k-home-1',
        route: 'business-category',
        resource: 'Partner - Sektor Bisnis',
        action: 'manage',
      },
      {
        title: 'Tipe Bisnis',
        komicon: 'k-chart-21',
        route: 'business-type',
        resource: 'Partner - Tipe Bisnis',
        action: 'manage',
      },
      {
        title: 'Organisasi',
        komicon: 'k-user-octagon',
        route: 'organization',
        resource: 'Partner - Organisasi',
        action: 'manage',
      },
    ],
  },
]
